/** Folio format: CT-YYYY-NNN (sequence per year, zero-padded to 3 digits, grows beyond 999). */
export function formatFolio(year: number, sequence: number): string {
  return `CT-${year}-${String(sequence).padStart(3, "0")}`;
}

/** Returns an ISO date (YYYY-MM-DD) `days` days after `from`, in UTC. */
export function addDays(from: Date, days: number): string {
  const result = new Date(from.getTime() + days * 24 * 60 * 60 * 1000);
  return result.toISOString().slice(0, 10);
}

export const DEFAULT_VALIDITY_DAYS = 90;
